/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState, useCallback } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../../utils/customHooks";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";
import getCroppedImg from "../../utils/cropImage";
import { CropperWrapper } from "../../utils/CropperWrapper";
import ImageUploader from "../../utils/ImageUploader";

// WZ36 — KD463002WHITE 190x253
// Pozycje tekstów (style inline, w mm):
//   top   = górna krawędź pola tekstowego
//   left  = środek tekstu (textAlign center + translateX(-50%)) albo lewa krawędź (textAlign left)
//   right = prawa krawędź pola (textAlign right)
// maxWidthN = maks. szerokość tekstu w px — dłuższy tekst zmniejsza czcionkę.
// Uwaga: lineHeight w stylu InlineEdit nie działa (nadpisuje go `font: inherit`), zawsze wynosi 1.5.
export const Wz36: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("Album Jasia");
  const [text2, setText2] = useState<string>("15.06.2024");
  const [text3, setText3] = useState<string>("godz. 8:50 | 53 cm | 4500 g");
  const text1BasicSize = 61;
  const text2BasicSize = 27;
  const text3BasicSize = 27;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const { saveTemplate, isSaving } = useSaveTemplate();
  const [image, setImage] = useState<string | null>(null);
  const [croppedImage, setCroppedImage] = useState<string | null>(null);
  const [crop, setCrop] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState<number>(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);
  const [step, setStep] = useState<"select" | "crop" | "view">("select");

  const pdfWidth = "190mm"; // PDF width in mm
  const pdfHeight = "253mm"; // PDF height in mm
  const font1 = "DancingScript-Regular";
  const font2 = "ArialMT";
  const maxWidth1 = 375;
  const maxWidth2 = 209;
  const maxWidth3 = 451;
  // Okno na zdjęcie użytkownika
  const photoTop = "60.1mm";
  const photoLeft = "32.3mm";
  const photoWidth = "124.9mm";
  const photoHeight = "126.4mm";
  const photoAspect = 124.9 / 126.4;

  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number,
    fontFamily: string,
    maxWidth: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px ${fontFamily}`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  // Czekamy na załadowanie fontu, inaczej canvas mierzy tekst fontem zastępczym.
  const ensureFont = (fontFamily: string) => document.fonts.load(`1em ${fontFamily}`);

  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText1(adjustFontSize(text1, fontSizeText1, text1BasicSize, 14, font1, maxWidth1))
    );
  }, [text1]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText2(adjustFontSize(text2, fontSizeText2, text2BasicSize, 10, font2, maxWidth2))
    );
  }, [text2]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText3(adjustFontSize(text3, fontSizeText3, text3BasicSize, 10, font2, maxWidth3))
    );
  }, [text3]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      croppedImage,
      true
    );
  };

  const handleCropComplete = useCallback((croppedArea: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleShowCroppedImage = useCallback(async () => {
    if (image && croppedAreaPixels) {
      const croppedImg = await getCroppedImg(image, croppedAreaPixels);
      setCroppedImage(croppedImg);
      setStep("view");
    }
  }, [image, croppedAreaPixels]);

  return (
    <div style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#ffffff", padding: "80px",
      position: "relative",
    }}>
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />
      <div style={{ position: "absolute", top: "10px", left: "0px", right: "0px", margin: "auto", color: "white", width: "480px", maxWidth: "100%", height: "70px", gap: "30px", display: "flex", alignItems: "center" }}>
        <ImageUploader
          onImageChange={(image) => setImage(image)}
          setStep={setStep}
        />
        {step === "crop" && (
          <p>
            Aby wykadrować zdjęcie możesz kręcić kółkiem myszy i przesuwać obraz
          </p>
        )}
        <div style={{}}>
          {step !== "crop" && (
            <Button onClick={handleSave} disabled={isSaving}>
              {isSaving ? "Zapisywanie..." : "Zapisz"}
            </Button>
          )}
          {step === "crop" && (
            <Button onClick={handleShowCroppedImage}>Zakończ kadrowanie</Button>
          )}
        </div>
      </div>

      <div
        id="printable-content"
        style={{
          position: "relative",
          width: pdfWidth,
          height: pdfHeight,
          fontFamily: "DancingScript-Regular, ArialMT",
          backgroundColor: "#ffffff",
          margin: "auto",
        }}
      >
        {/* Album Jasia */}
        <InlineEdit
          value={text1}
          setValue={setText1}
          style={{
            fontSize: `${fontSizeText1}px`,
            fontFamily: font1,
            color: "#b2b9ab",
            position: "absolute",
            top: "187.3mm",
            left: "95.6mm",
            width: `${maxWidth1 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "0.2px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 15.06.2024 */}
        <InlineEdit
          value={text2}
          setValue={setText2}
          style={{
            fontSize: `${fontSizeText2}px`,
            fontFamily: font2,
            color: "#e3b77a",
            position: "absolute",
            top: "217.1mm",
            left: "95.5mm",
            width: `${maxWidth2 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "-0.3px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* godz. 8:50 | 53 cm | 4500 g */}
        <InlineEdit
          value={text3}
          setValue={setText3}
          style={{
            fontSize: `${fontSizeText3}px`,
            fontFamily: font2,
            color: "#e3b77a",
            position: "absolute",
            top: "226.5mm",
            left: "95.5mm",
            width: `${maxWidth3 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />

        {/* Step: Crop */}
        {image && step === "crop" && (
          <CropperWrapper
            image={image}
            crop={crop}
            zoom={zoom}
            aspect={photoAspect}
            cropShape="round"
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={handleCropComplete}
            style={{
              top: photoTop,
              left: photoLeft,
              width: photoWidth,
              height: photoHeight,
              transform: "none",
            }}
          />
        )}

        {/* Step: View */}
        {croppedImage && step === "view" && (
          <img
            src={croppedImage}
            alt=""
            style={{
              position: "absolute",
              top: photoTop,
              left: photoLeft,
              width: photoWidth,
              height: photoHeight,
              objectFit: "cover",
              borderRadius: "50%",
              zIndex: 1,
            }}
          />
        )}

        <img
          src="/images/KD463002_WZ36.svg"
          alt=""
          style={{ width: "100%", height: "100%", position: 'absolute', top: '0', left: '0', zIndex: '2' }}
        />
      </div>
    </div>
  );
};
